module.exports = __webpack_public_path__ + "img/dq_pic_outlier_smart.95237592.png";